
import { Drawer } from "element-ui"
import clickCollect from "@/components/deliveryMethod/clickCollect.vue"
// import Address from "@/components/address/index.vue"
import { getOnlineStoreTags } from "@/api/delivery"
import Storage from "@/utils/storage"

export default {
  components: {
    [Drawer.name]: Drawer,
    clickCollect
    // Address
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    deliveryMethodValue: {
      type: String,
      default: "clickCollect"
    }
  },
  data() {
    return {
      curVisible: this.visible,
      tabOptions: [
        {
          label: this.$t("deliveryMethod.homeDelivery"),
          value: "homeDelivery"
        },
        {
          label: this.$t("deliveryMethod.clickCollect"),
          value: "clickCollect"
        }
      ],
      activeTabValue: "clickCollect",
      callback: null,
      tags: []
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
      if (val) {
        this.activeTabValue = this.deliveryMethodValue
        // this.getOnlineStoreTags()
      }
    }
  },
  methods: {
    getTag(type = "clickCollect") {
      const shipmentType = type === "homeDelivery" ? 1 : 2
      const target = this.tags.find(item => item.shipmentType === shipmentType) || {}
      return target.tip || ""
    },
    async getOnlineStoreTags() {
      const { custId } = Storage.get("accountInfo", { useBase64: true }) || {}
      const { commonReqParams } = this.$commonParams
      const { data: res } = await getOnlineStoreTags({
        param: JSON.stringify({
          latitude: commonReqParams.deliveryLat,
          longitude: commonReqParams.deliveryLng,
          custId: custId || ""
        })
      })
      this.tags = res.tags || []
    },
    toggleTab(value) {
      if (this.activeTabValue === value) return
      this.activeTabValue = value
    },
    handleClose() {
      this.$emit("close")
      if (this.callback) {
        this.callback("close")
        this.curVisible = false
      }
    },
    handleBack() {
      this.$emit("back")
    }
  }
}
